import { useState } from 'react';

const MAX_SIZE_MB = 5;
const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

export default function useAvatarUpload(initialPreview = null) {
  const [avatarFile, setAvatarFile] = useState(null);
  const [avatarPreview, setAvatarPreview] = useState(initialPreview);
  const [avatarError, setAvatarError] = useState('');

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > MAX_SIZE_BYTES) {
      setAvatarError(`Image must be smaller than ${MAX_SIZE_MB}MB.`);
      e.target.value = '';
      return;
    }

    setAvatarError('');
    setAvatarFile(file);

    const reader = new FileReader();
    reader.onloadend = () => setAvatarPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const reset = () => {
    setAvatarFile(null);
    setAvatarPreview(initialPreview);
    setAvatarError('');
  };

  return {
    avatarFile,
    avatarPreview,
    avatarError,
    handleAvatarChange,
    reset,
  };
}
